var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z",
    transform: "translate(-265 -330) translate(11 94) translate(16 220) translate(226 4) translate(12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#888",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.5 3L5.5 8 10.5 13",
    transform: "translate(-265 -330) translate(11 94) translate(16 220) translate(226 4) translate(12 12) matrix(-1 0 0 1 16 0)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight16);
export default __webpack_public_path__ + "static/media/arrow-right-16.50da35c38f2e3b64ed3736acea40d5f3.svg";
export { ForwardRef as ReactComponent };